/**
 * Resolve which canonical Support Case conversation to auto-open during
 * Support Mode / Impersonate into Case.
 *
 * Prefer openSupportTicketId (explicit deep-link), then supportTicketId
 * (canonical case bound to the impersonation session / banner Case ID).
 */
export function resolveImpersonationSupportTicketId(session) {
  if (!session || typeof session !== "object") return null;
  const openId = String(session.openSupportTicketId || "").trim();
  if (openId) return openId;
  const supportId = String(session.supportTicketId || "").trim();
  return supportId || null;
}

// NOTE: there is intentionally no "pin the deep-linked Case first" helper.
// List position is owned solely by `sortTicketsForTab` (canonical per-tab
// ordering); a deep-linked Case is expanded and scrolled into view instead.

/**
 * Whether the Support page should auto-open a bound case from the session.
 * True for Impersonate into Case and any Support Mode session with a case id.
 */
export function shouldAutoOpenSupportCase(session) {
  return Boolean(resolveImpersonationSupportTicketId(session));
}
